import { type Command } from '@telespot/core';
import { ILicenseInfo } from '@telespot/domain';

/**
 * Details for {@link RegisterOrganization}
 *
 * @group Organizations
 * @category Payloads
 */
export interface RegisterOrganizationDetails {
  organizationId?: string;
  name: string;
  logo?: File | undefined;
  license: ILicenseInfo;
  userId: string;
}

/**
 * Command registration token for {@link RegisterOrganization}
 *
 * @group Organizations
 * @category Tokens
 */
export const REGISTER_ORGANIZATION = 'organizations:registerOrganization';

/**
 * Registers a new organization or updates an existing one.
 * It also affiliates the user that created the organization.
 *
 * @group Organizations
 * @category Commands
 */
export class RegisterOrganization implements Command<typeof REGISTER_ORGANIZATION, RegisterOrganizationDetails> {
  public readonly name = REGISTER_ORGANIZATION;
  constructor(public readonly details: Readonly<RegisterOrganizationDetails>) {}
}
